module.exports = __webpack_public_path__ + "images/line_friend_lp/mv-object-top_98a246b8e3f4d0d636678ed9d8ff6a6c.png";